import React, { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { motion } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: 'What software product do you offer ?',
    answer: 'We offer: E-wallet Software Solution – where individual and corporate clients are able to top up accounts via SEPA/SWIFT transfers, Debit/Credit Cards, APM\'s, Exchange Currencies, Send to the IBAN Account or make Payouts to Cards. Crypto Exchange Platform – this product is often used by licensed Estonian, Lithuanian and Polish Crypto-Companies. Clients of Crypto-Platform are able to Buy/Sell/Receive/Send Digital Assets and Fiat. Crypto Processing and Crypto Checkout Widget . Crypto Processing allows you to provide with the processing services and to collect Crypto Payments for customers who already have crypto currencies. Crypto Checkout Widget allows you to implement payment page on your partner\'s website, where their customers will be able in iFrame without redirect pass KYC and buy Cryptocurrency. Payment Gateway – if you want to become a PSP or need relevant software solution to collect payments for your own business this product will cover all your needs. All in One – all these products are integrated in one technical solution and are divided by modules, due this you can get all in one ecosystem or add in any time upon your request.',
  },
  {
    question: 'What if I need to implement AML/KYC tools?',
    answer: 'We have integration with SumSub.com services and Crystal Blockchain Monitoring. If you need any additional KYC/AML provider, without any doubts we will be able to implement this development.',
  },
  {
    question: 'What integrations do you have?',
    answer: 'Every quarter the list of integrations raise up. We have several sets: 1. Banks, Acquiring services. 2. Blockchain technologies. 3. AML/KYC services, internal and outsource. 4. System features. All integrations are available for existing customers for free, the list of integrations depends on your selected product. Also, we collect the information from customers and most valued integrations has the highest priority and will be done without additional fees. If you need unique integration and don\'t wont to share it with Akrbit community we can develop it according to the Agreement.',
  },
  {
    question: "What if I don't have IT team, who will manage the product?",
    answer: 'In general in-house IT team is not required. We can develop the project from 0, we are able to develop the website, brand book, setup mailserver, add content, take part in communication with your partnerts which affect technical part of the software.',
  },
  {
    question: 'What if regulator or partner has asked to implement changes?',
    answer: 'Our software meets EU standards. Nevertheless we have met such situations when our customers were asking to add some extra changes in the product after the setup. Our team are always ready to implement changes if it affect on your business positively.',
  },
  {
    question: 'Who are your customers?',
    answer: 'Our customers are: Licensed crypto-exchange companies from Estonia, Lithuania, Poland, Czech Republic, Bulgaria. Electronic Money Institutions (EMI\'s), EMD Agents and Distributors from United Kingdom, Canada, Lithuania. Payment Service Providers (PSP\'s) from Canada, Hong-Kong, United Kingdom.',
  },
];

const FAQSection: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: '60px', md: '80px' },
        backgroundColor: '#F9F9F9',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Container maxWidth="xl" sx={{ width: '90%', mx: 'auto' }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            visible: { transition: { staggerChildren: 0.3 } }
          }}
        >
          <motion.div variants={itemVariants}>
            <Box sx={{ textAlign: 'left', mb: '2.25rem', padding: '0px 0px 40px 0px' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '32px', md: '48px' },
                  fontWeight: 600,
                }}
              >
                Frequently Asked Questions
              </Typography>
            </Box>
          </motion.div>

          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            style={{ margin: '0 auto' }}
          >
            {faqs.map((faq, index) => (
              <motion.div variants={itemVariants} key={index}>
                <Accordion
                  expanded={expanded === `panel${index}`}
                  onChange={handleChange(`panel${index}`)}
                  sx={{
                    mb: '10px',                                                                                     
borderRadius: '16px 16px 16px 16px',                                                             
boxShadow: 'none',                                                                               
border: 'none',                                                                                  
backgroundColor: 'transparent', 
                    '&:before': {
                      display: 'none',
                    },
                    '&.Mui-expanded': {
                      backgroundColor: '#FAFAFA', 
                      '& .MuiAccordionSummary-root': {  
                        backgroundColor: '#FAFAFA', 
                        borderRadius: '16px 16px 0px 0px',
                      },
                    },
                    '& .MuiAccordionSummary-root': {
                      borderRadius: '16px 16px 0px 0px',
                      overflow: 'hidden', 
                    },
                    '& .MuiAccordionDetails-root': { 
                      backgroundColor: '#FAFAFA',
                      borderRadius: '0px 0px 16px 16px',
                      overflow: 'hidden',  
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#070707' }} />}
                    sx={{
                      padding: '30px 30px 30px 30px',
                      '& .MuiAccordionSummary-content': {
                        my: '0px',
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: '24px',
                        fontWeight: 600,
                        color: '#070707',
                        lineHeight: '1.4em',
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{
                    padding: '0px 60px 35px 35px',
                    marginTop: '0px'
                  }}>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        color: 'gray.500',
                        lineHeight: 1.6,
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FAQSection;
